<template lang="pug">
    div.simple-modal-layout
        div.simple-modal-layout__overlay(@click.self="close(true)")

        div.simple-modal-layout__window(ref="modal")
            header.simple-modal-layout__header
                div.simple-modal-layout__header-close-button(@click="close(true)")
                    svg-icon(iconId="close-cross")

            section.simple-modal-layout__section
                slot(name="section")
            
            footer.simple-modal-layout__footer(v-if="!disableButtons")
                slot(name="buttons" :approve="approve" :cancel="cancel")
                    button-control.simple-modal-layout__cancel-button(v-if="!disableCancelButton" mode="cancel" @click="cancel") {{ cancelButtonText }}
                    button-control.simple-modal-layout__confirm-button(@click="approve") {{ confirmButtonText }}
</template>

<script>
import eventBus from '../lib/event-bus'
import events from '../lib/events'

export default {
    name: 'simple-modal-layout',
    props: {
        level: {
            type: Number,
            required: true,
        },
        confirmButtonText: {
            type: String,
            default: 'Save',
        },
        cancelButtonText: {
            type: String,
            default: 'Cancel',
        },
        disableButtons: Boolean,
        disableCancelButton: Boolean,
    },
    methods: {
        close(justClose) {
            this.$emit('close')
            if (justClose) {
                this.$emit('justClose')
            }
            eventBus.$emit(events.CLOSE_MODAL, this.level)
        },
        approve() {
            this.$emit('approve', {
                success: () => eventBus.$emit(events.CLOSE_MODAL, this.level),
            })
        },
        cancel() {
            this.$emit('cancel')
            this.close()
        },

        getModalEl() {
            return this.$refs.modal
        },
    },
}
</script>
